import React, { Fragment } from "react";
import { PropTypes } from "prop-types";
import HtmlTooltip from "./HtmlTooltip";

export default function CustomFields({ type }) {
  return (
    <HtmlTooltip
      type={type}
      title={
        <Fragment>
          <p>
            <b>Custom Fields</b>
          </p>
          <p>
            Custom fields follow the structure outlined below. On create or
            update transactions, the id, name, and datatype values cannot be
            updated.
            <pre>
              <code>
                {`
{
  “id”: number,
  “name”: string,
  “value”: string: Value of custom field,
  “dataType”: string: 
}
`}
              </code>
            </pre>
          </p>
        </Fragment>
      }
    ></HtmlTooltip>
  );
}
CustomFields.propTypes = {
  type: PropTypes.string.isRequired
};
